const live = {
    state: {
        liveOptParty: 0, //默认直播放 与liveParty不冲突  0 全部 1 主办 2 展商
        liveType:1,//直播类型 1 直播，2 回放
        liveState:sessionStorage.getItem('liveState')?sessionStorage.getItem('liveState')*1:0,//直播状态 0全部，1代开始，2直播中，3已完成
        liveParty:sessionStorage.getItem('liveParty')?sessionStorage.getItem('liveParty')*1:0,//开播方 0 全部 1 主办 2 展商
        activityType:sessionStorage.getItem('activityType')?JSON.parse(sessionStorage.getItem('activityType')):[],//活动/直播类型
        orderDesc:sessionStorage.getItem('orderDesc')?sessionStorage.getItem('orderDesc')*1:0,//0默认排序(推荐排序)  1时间排序(开播时间倒序) 2人气排序(观看人数倒序) 3开始时间升序
        moreType:sessionStorage.getItem('moreType')?sessionStorage.getItem('moreType')*1:0//更多类型，默认全部，1 推荐更多 2 热度
        ,totalPage:1//直播列表总条数
        ,pageNum:0//当前页码
        ,liveLists:[]//列表数据
        ,totalPage1:1//主办直播列表总条数
        ,pageNum1:0//主办当前页码
        ,liveLists1:[]//主办列表数据
        ,pageRows:12//一页几个
        ,liveName:sessionStorage.getItem('liveName')||''
        ,liveSponsorName:sessionStorage.getItem('liveSponsorName')||''
    },
  
    mutations: {
        liveChange:(state,res)=>{
            state[res.key]=res.val;
            if(typeof res.val!=="string"){
                sessionStorage.setItem(res.key,JSON.stringify(res.val));
            }else{
                sessionStorage.setItem(res.key,res.val);
            }
            
        }
    },
    getters:{
        getLiveState:(state)=>{
            return state
        }
    },
    actions:{
        getMoreType(c){
          console.log(c)
        }
    }
  
  }
  
  export default live
  